module.exports = __webpack_public_path__ + "static/media/avatar-S_K.a57449a3.png";